<template>
    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="container">
             <v-breadcrumb value1="首页" :value2="value2" :value3="value3" :url="url"></v-breadcrumb>
             <div class="container_box">
                 <!--<div class="box_top">
                     <span >廉江动态</span>丨<span> 最热 </span>丨<span> 最新 </span>丨<span> 精华 </span>
                 </div>-->
                 <div class="box_item mt20" v-for="i in dataList">
                     <img class="i hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                     <div class="item_right">
                         <div class="right_title hover" @click="toDetail(i.path)">
                             {{i.title}}
                            <!-- <img style="float: right;margin-right: 50px" src="../../assets/img/share.png">-->
                         </div>
                         <p >
                             {{i.summary}}
                         </p>
                         <div class="right_down">

                              时间:{{i.time}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <span class="hover" @click="toDetail(i.path)">阅读全文 >></span>


                         </div>

                     </div>


                 </div>



             </div>



        </div>


        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                ljcode:null,
                columnId:null,
                rootColumnId:null,
                dataList:null,
                url:null,
                value2:null,
                value3:null,
                bindData:[
                    {
                        name:'廉江概览',
                        url:'#/list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cabebd0006'
                    },
                    {
                        name:'廉江动态',
                        url:'#/list2?ljcode=ljdt&columnId=40288a9d6e91c70a016e91caf27c0007&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91caf27c0007'
                    },
                    {
                        name:'节庆活动',
                        url:'#/jqhd?ljcode=jqhd&columnId=40288a9d6e91c70a016e91cb31640008&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cb31640008'
                    },
                    {
                        name:'音画廉江',
                        url:'#/yhlj?ljcode=yhlj&columnId=40288a9d6e91c70a016e91cb9d910009&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cb9d910009'
                    }
                ]

            }
        },
        created() {
            this.ljcode = this.$route.query.ljcode;
            if(this.ljcode=='lyxl'){
                this.value2 = '互动交流';
                this.value3 = '旅游线路'

            }else{
                this.value2 = '了解廉江';
                this.value3 = '廉江动态'
            }
            this.columnId = this.$route.query.columnId;
            this.rootColumnId = this.$route.query.rootColumnId;
            this.url = [this.ljcode,this.rootColumnId,this.columnId];
            this.getList();
        },
        methods:{
            getList(){
                let that = this;
                let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=10&currentPage=1`;
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data.list;

                    data.forEach(v=>{
                        v.coverImageUrl = apiimg+v.coverImageUrl;
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
                        v.time = that.common.date2Local(v.createDate);
                    });
                    this.dataList = data;
                    console.log(data);
                })
            },
            toDetail(v){
                this.$router.push({path:`/detail2?${v}`})
            }
        },
        components:{
            "v-route":route
        }
    }
</script>

<style lang="less" scoped>
    .nav{
        height: 350px;
        background: url("../../assets/img/headerbanner.jpg");
    }
    .container_box{
        .box_top{
            width: 400px;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
            color: #159089;
            text-align: left;
            margin: 20px 0 20px 10px;
        }
        .box_item{
            height: 200px;
            border-radius:4px;
            margin-bottom: 20px;
            border-bottom: 2px solid rgb(235,235,235);
            display: flex;
            .i{
                 width: 296px;
                 height: 170px;
                margin-right: 20px;
            }
            .item_right{
                flex: 1;
                text-align: left;
                .right_title{
                    margin-bottom: 20px;
                    height: 20px;
                    line-height: 20px;
                    color:rgba(51,51,51,1);
                    font-size: 18px;
                }
                p{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height: 20px;
                }
                .right_down{
                    margin-top: 20px;
                    margin-right: 20px;
                    text-align: left;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                }
            }

        }

    }


</style>
